<template>
  <div>
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
          </div>
          <div style="text-align: center; font-size: 0.35rem">投诉查询</div>
          <div class="saveDraft" @click="complaint">我要投诉</div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div class="tab_con m_flex_box flex_vb flex_hc">
      <span :class="tab === 0 ? 'active' : ''" @click="changeTab(0)"
        >我的投诉</span
      >
      <span :class="tab === 1 ? 'active' : ''" @click="changeTab(1)"
        >投诉查询</span
      >
    </div>
    <div v-show="tab == 0">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="" />
          </div>
          <div class="inner bor_b" v-for="(item, index) in list" :key="index">
            <div class="data_modular f_line">
              <!-- <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">处理结果:</span>
                  <span></span>
                </p>
              </div> -->
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">投诉小区:</span>
                  <span>{{
                    item.complaints.communityName
                      ? item.complaints.communityName
                      : "-"
                  }}</span>
                </p>
              </div>
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">物业:</span>
                  <span>{{
                    item.complaints.propertyName
                      ? item.complaints.propertyName
                      : "-"
                  }}</span>
                </p>
              </div>
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">投诉类型:</span>
                  <span>{{ item.complaints.typeId1Name }}</span>
                </p>
              </div>
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">投诉描述:</span>
                  <span>{{ item.complaints.typeId2Name }}</span>
                </p>
              </div>
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">投诉内容:</span>
                  <span>{{ item.complaints.content }}</span>
                </p>
              </div>
              <div class="row row_flex">
                <div class="row_flex_auto">
                  <p v-for="(item1, index1) in item.imageList" :key="index1">
                    <img :src="imgPath + 'sClf/' + item1 + '.jpg'" alt="" />
                  </p>
                </div>
              </div>
              <div
                style="
                  text-align: right;
                  padding-right: 0.2rem;
                  padding-top: 0.4rem;
                "
              >
                {{ item.complaints.createDate }}
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div v-show="tab == 1" class="tab_bar">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz flex_gai">
          <div class="m_flex_box flex_vc">
            <div class="search_con m_flex_box flex_vc">
              <van-icon name="search" />
              <input
                class="middle"
                type="text"
                v-model="tsbh"
                placeholder="搜索"
                @keyup.enter="querytsbh"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="no_data" v-if="JSON.stringify(objData) == '{}'">
        <img src="@/assets/img/nodata.png" alt="" />
      </div>
      <div class="data_modular f_line" v-else>
        <div class="row">
          <p class="m_flex_box">
            <span class="f_title">处理结果:</span>
            <span>{{ objData.operate }}</span>
          </p>
        </div>
        <div class="row">
          <p class="m_flex_box">
            <span class="f_title">投诉类型:</span>
            <span>{{ objData.qname }}</span>
          </p>
        </div>
        <div class="row">
          <p class="m_flex_box">
            <span class="f_title">类型描述:</span>
            <span>{{ objData.typename }}</span>
          </p>
        </div>
        <div class="row">
          <p class="m_flex_box">
            <span class="f_title">投诉内容:</span>
            <span>{{ objData.content }}</span>
          </p>
        </div>
      </div>
      <!-- <van-pull-refresh>
        <van-list
          finished-text="没有更多了"
        >
          <div class="no_data" v-if="!list1.length">
            <img src="@/assets/img/nodata.png" alt="" />
          </div>
          <div class="inner bor_b" v-for="(item, index) in list1" :key="index">
            <div class="data_modular f_line">
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">处理结果:</span>
                  <span></span>
                </p>
              </div>
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">投诉小区:</span>
                  <span>{{
                    item.complaints.communityName
                      ? item.complaints.communityName
                      : "-"
                  }}</span>
                </p>
              </div>
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">物业:</span>
                  <span>{{
                    item.complaints.propertyName
                      ? item.complaints.propertyName
                      : "-"
                  }}</span>
                </p>
              </div>
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">投诉类型:</span>
                  <span>{{ item.complaints.typeId1Name }}</span>
                </p>
              </div>
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">投诉描述:</span>
                  <span>{{ item.complaints.typeId2Name }}</span>
                </p>
              </div>
              <div class="row">
                <p class="m_flex_box">
                  <span class="f_title">投诉内容:</span>
                  <span>{{ item.complaints.content }}</span>
                </p>
              </div>
              <div class="row row_flex">
                <div class="row_flex_auto">
                  <p v-for="(item1, index1) in item.imageList" :key="index1">
                    <img :src="imgPath + 'sClf/' + item1 + '.jpg'" alt="" />
                  </p>
                </div>
              </div>
              <div
                style="
                  text-align: right;
                  padding-right: 0.2rem;
                  padding-top: 0.4rem;
                "
              >
                {{ item.complaints.createDate }}
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh> -->
    </div>
  </div>
</template>
<script>
import qs from "qs";
export default {
  data() {
    return {
      inpText: "",
      appToken: "",
      isApp: this.$route.query.isApp || false,
      isWx: this.$route.query.isWx || false,
      wxAppToken:this.$route.query.user || '',
      tab: 0,
      list: [],
      objData: {},
      pageIndex: 1,
      tsbh: "",
      isLoading: false,
      loading: false,
      finished: false
    };
  },
  created() {
    this.assignmentTooken();
  },
  mounted() {
    // if (this.isApp) {
    //   window.sessionStorage.setItem("isApp", true);
    // }
    // if (this.isWx) {
    //   window.sessionStorage.setItem("isWx", true);
    // }
    if(this.wxAppToken){
      window.sessionStorage.setItem("wxAppToken", this.wxToken);
    }
  },
  methods: {
    complaint() {
      this.$router.push({
        path: "/newComplaints",
        query: {
          isApp: this.isApp,
          isWx:this.isWx
        },
      });
    },
    onRefresh() {
      this.loading = true;
      this.finished = false;
      this.pageIndex = 1;
      this.$set(this, "list", []);
      this.onLoad(1);
    },
    assignmentTooken() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        var ua = navigator.userAgent;
        var uaList = ua.split(" ");
        var token = "";
        for (var i = 0; i < uaList.length; i++) {
          if (uaList[i].indexOf("token") > -1) {
            token = uaList[i].split("=")[1];
            break;
          }
        }
        this.appToken = token;
      } else {
        if ((this.isWx && this.isWx != "false") || this.isWx == "true") {
          if (window.sessionStorage.getItem("wxAppToken")) {
            this.appToken = sessionStorage.getItem("wxAppToken");
          }
        } else {
          if (JSON.parse(window.localStorage.getItem("tokenObj"))) {
            this.appToken = JSON.parse(
              localStorage.getItem("tokenObj")
            ).appToken;
          }
        }
      }
    },
    onLoad(type) {
      this.$http
        .post(
          "house/wyts/getMyComplaintsList.do",
          qs.stringify({
            pageSize: 10,
            currPageNo: this.pageIndex,
            appToken: this.appToken,
          })
        )
        .then((res) => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj);
            this.loading = false;
            this.$set(this, "pageIndex", this.pageIndex + 1);
            if (res.obj.length == 0) {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        });
    },
    querytsbh() {
      this.$http
        .post(
          "house/wyts/getTsResults.do",
          qs.stringify({
            appToken: this.appToken,
            tsbh: this.tsbh,
          })
        )
        .then((res) => {
          if (res.success) {
            this.objData = res.obj;
          } else {
            this.objData = {};
            this.$toast(res.msg);
          }
        });
    },
    goback() {
      if (this.isApp) {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    },
    changeTab(num) {
      this.tab = num;
    },
  },
};
</script>
<style lang="less" scoped>
.tab_bar {
  .top_header {
    height: 0.7rem;
    padding: 0.2rem 0rem;
    width: 7.04rem;
    margin: 0 auto;
    &.top_sm {
      padding: 0.1rem;
    }
    .flex_gai {
      justify-content: center;
    }
    .search_con,
    .search_con_l {
      background-color: #f6f6f6;
      border: 1px solid #f0f0f0;
      border-radius: 0.7rem;
      height: 0.7rem;
      box-sizing: border-box;
      font-size: 0.26rem;
      padding: 0 0.3rem;
      color: #303030;
      i {
        font-size: 0.36rem;
        margin-right: 0.2rem;
      }
    }
    input {
      width: 80%;
      height: 0.7rem;
      background-color: transparent;
    }
    .search_con {
      width: 6rem;
    }
    .search_con_l {
      width: 5.72rem;
    }
    .to_map {
      font-size: 0.28rem;
      img {
        margin-right: 0.06rem;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
}

.row_flex {
  width: 100%;
  overflow-y: scroll;
  .row_flex_auto {
    display: flex;
    overflow-y: auto;
    flex-wrap: nowrap;
  }
  p {
    margin-top: 0.2rem;
    margin-left: 0.2rem;
    img {
      width: 3rem;
      height: 2rem;
    }
  }
}
.data_modular {
  padding: 0.5rem 0 0.5rem 0.3rem;
  .row {
    padding: 3px 0;
    font-size: 0.3rem;
  }
}
.bor_b {
  border-bottom: 2px solid #f2f2f2;
}
.fixed_pad {
  padding-top: 1.1rem;
}
.tab_con {
  height: 1rem;
  background-color: #fff;
  z-index: 9;
  span {
    font-weight: 800;
    font-size: 0.3rem;
    margin: 0.3rem;
    text-align: center;
  }
  .active {
    color: #3072f5;
    position: relative;
    font-size: 0.33rem;
    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      margin-left: -0.2rem;
      background-color: #3072f5;
      width: 0.4rem;
      height: 0.04rem;
    }
  }
}
.saveDraft {
  padding: 0.1rem 0.15rem;
  font-size: 0.2rem;
  border-radius: 0.1rem;
  border: 1px solid #007fff;
  color: #007fff;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
}
</style>
